import { Spine, MIN_PAGES_FOR_SPINE_TEXT, DEFAULT_TEXT_COLOR, DEFAULT_BG_COLOR } from './Spine'

const COVER_TYPE_IMAGE = 'image'
const COVER_TYPE_TEMPLATE = 'template'

/*
  Базовый класс обложки. Наследники (ImageCover, TemplateCover) отличаются источником
  лицевой и задней сторон; корешок общий для обоих.

  Модель не сериализуется: данные живут в plain-объекте project.cover, а Cover — обёртка
  над ним (см. Project#coverModel).
*/
class Cover {
  project
  data

  constructor (project, data) {
    this.project = project
    this.data = data || {}
  }

  get type () {
    return COVER_TYPE_IMAGE
  }

  get spineTitle () {
    return this.data.spineTitle || this.project?.bookName || ''
  }

  get spineFontSize () {
    return this.data.spineFontSize ?? null
  }

  get spineTextColor () {
    return this.data.spineTextColor || DEFAULT_TEXT_COLOR
  }

  get spineBgColor () {
    return this.data.spineBgColor || DEFAULT_BG_COLOR
  }

  /* Текст на корешке печатается только у достаточно толстых книг. */
  get canPrintSpineText () {
    return (this.project?.pages?.length || 0) >= MIN_PAGES_FOR_SPINE_TEXT
  }

  get authorName () {
    const authors = this.project?.authors || []
    const main = authors.find((author) => author.role === '著') || authors[0]
    return main?.fullname?.trim() || ''
  }

  get spineWidthMm () {
    return this.project?.coverSpineWidthInMm || 0
  }

  createSpine (bleedMm) {
    return new Spine({
      widthMm: this.spineWidthMm,
      title: this.spineTitle,
      fontSizePt: this.spineFontSize,
      authorName: this.authorName,
      canPrintText: this.canPrintSpineText,
      textColor: this.spineTextColor,
      bgColor: this.spineBgColor,
      bleedMm
    })
  }

  get hasSpineError () {
    return this.createSpine().hasFontSizeError
  }

  /* Готова ли обложка к печати. */
  isComplete () {
    return false
  }

  /* Лист обложки для воркспейса; у image-обложки своего листа нет. */
  createSheet () {
    return null
  }
}

export { Cover, COVER_TYPE_IMAGE, COVER_TYPE_TEMPLATE }
